<div class="cb-form-container">
    @if(globalErrorPosition() == 'top'){
    <ng-container *ngTemplateOutlet="GlobalErrors"></ng-container>
    }
    <form [formGroup]="formGroup()">
        <div class="cb-form">
            @if(formGroups().length > 0){
            @for(group of formGroups(); track group.id){
            <div class="cb-form-row" [class.cb-divider]="group.divider()">
                <ng-container *ngTemplateOutlet="GroupTemplate; context: {$implicit: group}"></ng-container>
            </div>
            }
            }@else {
            <div class="cb-form-group">
                @for(item of formItems(); track item.id){
                <ng-container *ngTemplateOutlet="FormItemTemplate; context: {$implicit: item}"></ng-container>
                }
            </div>
            }
        </div>
        @if(globalErrorPosition() == 'bottom'){
        <ng-container *ngTemplateOutlet="GlobalErrors"></ng-container>
        }
        @if(localControls()){
        <div class="cb-form-controls-container">
            <ng-content select="cb-form-controls"></ng-content>
        </div>
        }
        <ng-content></ng-content>


        <ng-template #GroupTemplate let-group>
            <div class="cb-form-group">
                @if(group.title() || group.subtitle()){
                <div class="cb-form-group-title">
                    @if(group.title()){
                    <h3>{{group.title()}}</h3>
                    }
                    @if(group.subtitle()){
                    <p>{{group.subtitle()}}</p>
                    }
                </div>
                }
                @if(group.formItems()?.length > 0){
                <div class="cb-form-grid" [style.grid-template-columns]="'repeat('+(group.columns() ?? 1)+', 1fr)'">
                    @for(item of group.formItems(); track item.id){
                    <ng-container *ngTemplateOutlet="FormItemTemplate; context: {$implicit: item}"></ng-container>
                    }
                </div>
                }

                @if(group.childrenGroups()?.length>0){
                <div class="cb-form-grid" [style.grid-template-columns]="'repeat('+(group.columns() ?? 1)+', 1fr)'">
                    @for(child of group.childrenGroups(); track child.id){
                    <ng-container *ngTemplateOutlet="GroupTemplate; context: {$implicit: child}"></ng-container>
                    }
                </div>
                }
            </div>
        </ng-template>

        <ng-template #FormItemTemplate let-item let-hideLabel="hideLabel">

            <div class="cb-form-item-container">
                @if(item.beforeTemplateRef()){
                <div class="cb-form-item-side" [ngClass]="(item.label)? 'pt-[1.6rem]' : ''">
                    <ng-container *ngTemplateOutlet="item.beforeTemplateRef()"></ng-container>
                </div>
                }
                <div class="cb-form-item">
                    @if(item.data()){
                    @switch(item.data().type){
                    @case('custom'){
                    <ng-container *ngTemplateOutlet="item.templateRef()"></ng-container>
                    }
                    @case('array'){
                    @let formArray = formGroup().getArrayControl(item.name());
                    @if(formArray){
                    <div [formArrayName]="item.name()" class="cb-form-array-container">
                        @if(item.children()){
                        <table>
                            <tr>
                                @for(subItem of item.children(); track subItem.id){
                                <th>{{subItem.label()}}</th>
                                }
                                <th></th>
                            </tr>
                            @if(formArray){
                            @for (control of (formArray.controls); track control.value) {
                            <tr [formGroupName]="$index">
                                @for(subItem of item.children(); track subItem.id){
                                <td>
                                    @if(standardInputs.includes(subItem.data().type)){
                                    <cb-form-input [formControlName]="subItem.name()"
                                        [error]="(control.get(subItem.name())?.invalid && control.get(subItem.name())?.touched) ?? false"
                                        [editorOptions]="subItem.editorOptions()" [data]="subItem.data()"
                                        [placeholder]="subItem.placeholder()" [hint]="subItem.hint()"
                                        (change)="subItem.change.emit($event)" (blur)="subItem.blur.emit($event)">

                                        <!-- THE EVENTUALLY CUSTOM TEMPLATE -->
                                        @if(subItem.templateRef()){
                                        <ng-template #ItemTemplate>
                                            <ng-container *ngTemplateOutlet="subItem.templateRef()"></ng-container>
                                        </ng-template>
                                        }
                                        <!--------------------------------------->

                                        <!-- THE SELECT INPUT CUSTOM TEMPLATES -->
                                        @if(subItem.data().type === 'select'){
                                        @if(subItem.selectOptionTemplateRef()){
                                        <ng-template #SelectOptionTemplate let-option>
                                            <ng-container
                                                *ngTemplateOutlet="subItem.selectOptionTemplateRef(); context: {$implicit:option}"></ng-container>
                                        </ng-template>
                                        }
                                        @if(subItem.selectValueTemplateRef()){
                                        <ng-template #SelectValueTemplate let-option>
                                            <ng-container
                                                *ngTemplateOutlet="subItem.selectValueTemplateRef(); context: {$implicit:option}"></ng-container>
                                        </ng-template>
                                        }
                                        }
                                        <!--------------------------------------->

                                    </cb-form-input>
                                    }@else {
                                    <ng-container
                                        *ngTemplateOutlet="FormItemTemplate; context: {$implicit: subItem, hideLabel:true}"></ng-container>
                                    }

                                    @if(control.get(subItem.name())?.invalid && control.get(subItem.name())?.touched){
                                    @for (item of (control.get(item.name)?.errors | keyvalue) | slice:0:1; track item) {
                                    @if(item.key === 'required'){
                                    <cb-form-error
                                        [message]="'COMMON.FORM_ERRORS.REQUIRED' | translate"></cb-form-error>
                                    }@else{
                                    @if(subItem.value().message){
                                    <cb-form-error
                                        [message]="subItem.value().message | translate:(subItem.value().attr ?? {})"></cb-form-error>
                                    }@else{
                                    <cb-form-error [message]="subItem.value() | translate"></cb-form-error>
                                    }
                                    }
                                    }
                                    }
                                </td>
                                }
                                <td>
                                    <cb-button type="iconOnly" size="sm" color="gray" hierarchy="secondary"
                                        icon="cb-base-outline-close"
                                        (click)="removeArrayRow(item.name(), $index)"></cb-button>
                                </td>
                            </tr>
                            }
                            }
                        </table>
                        }

                        <div class="cb-form-array-add">
                            <cb-button [disabled]="formArray.length >= getArrayMaxRows(item.name())"
                                hierarchy="secondary" color="gray" icon="cb-base-outline-add"
                                (click)="addArrayRow(item.name())" [label]="'COMMON.ADD' | translate"></cb-button>
                        </div>
                    </div>

                    }
                    }
                    <!-- CUSTOM FORM ITEMS -->
                    @case('link'){
                    <div class="cb-form-link" [ngClass]="'cb-align-'+(item.data().align ?? 'left')">
                        @if(item.data().url){
                        <a [attr.href]="item.data().url">{{item.label()}}</a>
                        }@else if(item.data().routerLink){
                        <a [routerLink]="item.data().routerLink">{{item.label()}}</a>
                        }
                    </div>
                    }
                    <!-- DEFAULT FORM ITEMS -->
                    @default{
                    <cb-form-input [formControlName]="item.name()"
                        [error]="(formGroup().get(item.name())?.invalid && formGroup().get(item.name())?.touched) ?? false"
                        [info]="(hideLabel)? null : item.info()" [required]="requiredFields.includes(item.name())"
                        [editorOptions]="item.editorOptions()" [data]="item.data()"
                        [label]="(hideLabel)? null : item.label()" [placeholder]="item.placeholder()"
                        [hint]="item.hint()" (change)="item.change.emit($event)" (blur)="item.blur.emit($event)">

                        <!-- THE EVENTUALLY CUSTOM TEMPLATE -->
                        @if(item.templateRef()){
                        <ng-template #ItemTemplate>
                            <ng-container *ngTemplateOutlet="item.templateRef()"></ng-container>
                        </ng-template>
                        }
                        <!--------------------------------------->

                        <!-- THE SELECT INPUT CUSTOM TEMPLATES -->
                        @if(item.data().type === 'select'){
                        @if(item.selectOptionTemplateRef()){
                        <ng-template #SelectOptionTemplate let-option>
                            <ng-container
                                *ngTemplateOutlet="item.selectOptionTemplateRef(); context: {$implicit:option}"></ng-container>
                        </ng-template>
                        }
                        @if(item.selectValueTemplateRef()){
                        <ng-template #SelectValueTemplate let-option>
                            <ng-container
                                *ngTemplateOutlet="item.selectValueTemplateRef(); context: {$implicit:option}"></ng-container>
                        </ng-template>
                        }
                        }
                        <!--------------------------------------->

                    </cb-form-input>
                    }
                    }
                    }

                    <!-- ERROR OF THE FORM ITEM -->
                    @if(formGroup().get(item.name())?.invalid && formGroup().get(item.name())?.touched){
                    @for (item of (formGroup().get(item.name())?.errors | keyvalue) | slice:0:1; track item) {
                    @if(item.key === 'required'){
                    <cb-form-error [message]="'COMMON.FORM_ERRORS.REQUIRED' | translate"></cb-form-error>
                    }@else{
                    @if(item.value.message){
                    <cb-form-error [message]="item.value.message | translate:(item.value.attr ?? {})"></cb-form-error>
                    }@else{
                    <cb-form-error [message]="item.value | translate"></cb-form-error>
                    }
                    }
                    }
                    }
                </div>
                @if(item.afterTemplateRef()){
                <div class="cb-form-item-side" [ngClass]="(item.label())? 'pt-[1.6rem]' : ''">
                    <ng-container *ngTemplateOutlet="item.afterTemplateRef()"></ng-container>
                </div>
                }
            </div>
        </ng-template>
    </form>
</div>

<ng-template #GlobalErrors>
    <div class="cb-form-errors-container">
        @if(formGroup().invalid && formGroup().touched){
        @for (item of (formGroup().errors | keyvalue) | slice:0:1; track item) {
        <cb-form-error [message]="item.value | translate"></cb-form-error>
        }
        }
        @if(globalError()){
        <cb-form-error [message]="globalError()!"></cb-form-error>
        }
        <ng-content select="cb-form-error"></ng-content>
    </div>
</ng-template>